import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const askForOpportunitiesSelector = (state: RootState) => state.jobPreferences;

export const updatePreferencesStatusSelector = createSelector(
    askForOpportunitiesSelector,
    (state) => state.updateState.status
);

export const updatePreferencesErrorSelector = createSelector(
    askForOpportunitiesSelector,
    (state) => state.updateState.errorCode
);
